// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope } from "~/hooks/useScope";
import { CREATE_AGENT } from "./action";

export function canCreateAgent(scope: Scope): boolean {
  return scope.iamActions.includes(CREATE_AGENT);
}
